import { isNil, trim } from 'lodash';

import i18next from '@/app/lib/i18next';
import { Account } from '@/app/network/models/v1/account';
import { UnifiedAccount } from '@/shared/unified-account';

export function getAccountLabel(account: Account | UnifiedAccount | undefined, suppressAlias = false) {
  if (isNil(account)) return '';

  const normalizedAlias = suppressAlias ? null : trim(account.alias);

  if (normalizedAlias) {
    return normalizedAlias;
  }

  let accountNumber = 0;
  if ('accountNumber' in account) {
    accountNumber = account.accountNumber;
  } else if ('account_number' in account) {
    accountNumber = account.account_number;
  }

  return i18next.t('account.label', { accountNumber: accountNumber, type: i18next.t(`accountType.${account.type}`) });
}
